import { DisputeStatus } from 'enums';
import styles from './DisputeStatusFilter.module.scss';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';
import { useUserInfo } from 'state';

const options = [
    {
        id: DisputeStatus.All,
        text: 'All'
    },
    {
        id: undefined,
        text: 'Open'
    },
    {
        id: DisputeStatus.Received,
        text: 'Received'
    },
    {
        id: DisputeStatus.InReview,
        text: 'In Review'
    },
    {
        id: DisputeStatus.VendorReview,
        text: 'Vendor Review'
    },
    {
        id: DisputeStatus.FinalReview,
        text: 'Final Review'
    },
    {
        id: DisputeStatus.Closed,
        text: 'Closed'
    }
];

const externalOptions = options.filter(({ id }) => id !== DisputeStatus.FinalReview);

type Props = {
    status: DisputeStatus | undefined,
    onStatusChange: (value?: DisputeStatus) => void
};

const DisputeStatusFilter = ({ status, onStatusChange }: Props) => {
    const { isInternalUser } = useUserInfo();

    return (
        <DropDownButton 
            className={styles.control}
            items={isInternalUser ? options : externalOptions}
            textField="text"
            text={`Dispute Status: ${options.find(({ id }) => id === status)?.text ?? 'All'}`}
            onItemClick={(e) => onStatusChange(e.item.id)}
        />
    );
};

export default DisputeStatusFilter;
